import {http} from "../../config/httpCommon";

export default {
    state: {
        priceLists: [],
        defaultPriceList: null,
    },
    mutations: {
        SET_PRICE_LIST(state, payload) {
            state.priceLists = payload
        },
        SET_DEFAULT_PRICE_LIST(state, payload) {
            state.defaultPriceList = payload
        }
    },
    actions: {
        async createPriceList({commit}, payload) {
            let res = await http.post('/pricelists', payload);
            return res;
        },
        async getPriceList({commit}, payload) {
            let res = await http.get('/pricelists');
            commit('SET_PRICE_LIST', res.data.result.pricelists.data);
            const defaultPriceList = res.data.result.pricelists?.data.find((priceList) => priceList.is_default === 1)
            commit('SET_DEFAULT_PRICE_LIST', defaultPriceList);
            return res.data.result.pricelists;
        },
        async updatePriceList({commit}, payload) {
            let res = await http.put(`/pricelists/${payload.id}`, payload.priceList);
            return res;
        },
        async deletePriceList({commit}, payload) {
            let res = await http.delete(`/pricelists/${payload.id}`);
            return res;
        },
        async importExcelTemplate(_, payload) {
            let res = await http.post('/pricelists/import', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return res;
        },
        async exportExcelTemplate() {
            let res = await http.get('/pricelists/export', {
                responseType: 'blob',
            }).then((res) => {
                const blob = new Blob([res.data],{type:res.headers['content-type']})
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'price_list_template.xlsx';
                link.click();
            })
            return res;
        },
        async assignPriceListToMerchant(_, payload) {
            let res = await http.put('/companies/'+payload.company_id, payload)
            return res;
        }
    },
    getters: {
        getPriceList(state) {
            return state.priceLists;
        },
        getDefaultPriceList(state) {
            return state.defaultPriceList;
        }
    }
}